module.exports = __webpack_public_path__ + "static/media/pato.bcd52293.mpeg";